export default "__VITE_ASSET__DIWG21p0__"